import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductService } from 'src/app/service/product.service';
import { Product } from './product';
import parseMoney from 'parse-money';

@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductFormComponent implements OnInit {

  formulario: FormGroup;
  nameProduct: string;
  carregando = false;

  constructor(
    private productService: ProductService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  carregar(id: number) {
    this.carregando = true;
    this.productService.findProductById(id).subscribe((response) => {
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.name.setValue(response.name);
      this.formulario.controls.price.setValue((response.price + '').replace('.', ','));
      this.formulario.controls.pricePort.setValue((response.pricePort + '').replace('.', ','));
      this.formulario.controls.priceReceivable.setValue((response.priceReceivable + '').replace('.', ','));
      this.formulario.controls.cost.setValue((response.cost + '').replace('.', ','));
      this.formulario.controls['active'].setValue(response.active ? 'true' : 'false');
      this.formulario.controls.stockQuantity.setValue(response.stockQuantity);
      this.formulario.controls.productMaster.setValue(response.productMaster);
      if (response.productMaster != null) {
        this.buscarProduto();
      } else {
        this.nameProduct = '';
      }
      this.formulario.controls.cean.setValue(response.cean);
      this.formulario.controls.ncm.setValue(response.ncm);
      this.formulario.controls.cest.setValue(response.cest);
      this.formulario.controls.cfop.setValue(response.cfop);
      this.formulario.controls.ceanTrib.setValue(response.ceanTrib);
      this.formulario.controls.cbenef.setValue(response.cbenef);
      this.formulario.controls.unidadeComercial.setValue(response.unidadeComercial);
      this.formulario.controls.unidadeTributaria.setValue(response.unidadeTributaria);
      this.formulario.controls.vinculoAdicional.setValue(response.vinculoAdicional);
      this.formulario.controls.pglp.setValue(response.pglp);
      this.formulario.controls.pgNn.setValue(response.pgNn);
      this.formulario.controls.pgNi.setValue(response.pgNi);
      this.formulario.controls.valorPart.setValue(response.valorPart);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Produto não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  submit() {
    const formValues = this.formulario.value;
    const product: Product = new Product(
      formValues.id,
      formValues.name,
      parseMoney(formValues.price)?.amount.toFixed(2),
      formValues.active,
      parseMoney(formValues.cost)?.amount.toFixed(2),
      parseMoney(formValues.pricePort)?.amount.toFixed(2),
      parseMoney(formValues.priceReceivable)?.amount.toFixed(2),
      formValues.stockQuantity,
      formValues.productMaster,
      formValues.cean,
      formValues.ncm,
      formValues.cest,
      formValues.cfop,
      formValues.ceanTrib,
      formValues.cbenef,
      formValues.unidadeComercial,
      formValues.unidadeTributaria,
      formValues.vinculoAdicional,
      formValues.pglp,
      formValues.pgNn,
      formValues.pgNi,
      formValues.valorPart
    );

    const request = formValues.id
      ? this.productService.update(product)
      : this.productService.save(product);

    request.subscribe(() => {
      this.snackBar.open(formValues.id ? 'Produto alterado com sucesso!' : 'Produto salvo com sucesso!', 'Sucesso', {
        duration: 2000
      });
      this.voltarConsulta();
    }, errorResponse => {
      this.snackBar.open(errorResponse.error.message, 'ERRO', { duration: 2000 });
    });
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      name: [null, [Validators.minLength(3), Validators.maxLength(50)]],
      price: [null, [Validators.minLength(1), Validators.maxLength(6)]],
      pricePort: [null, [Validators.minLength(1), Validators.maxLength(6)]],
      priceReceivable: [null, [Validators.minLength(1), Validators.maxLength(6)]],
      cost: [null, [Validators.minLength(1), Validators.maxLength(6)]],
      active: [null, Validators.required],
      stockQuantity: [null, Validators.required],
      productMaster: [null, null],
      cean: [null, null],
      ncm: [null, null],
      cest: [null, null],
      cfop: [null, null],
      ceanTrib: [null, null],
      cbenef: [null, null],
      unidadeComercial: [null, null],
      unidadeTributaria: [null, null],
      vinculoAdicional: [null, null],
      pglp: [null, null],
      pgNn: [null, null],
      pgNi: [null, null],
      valorPart: [null, null]
    });
  }

  limparFormulario() {
    this.router.navigate(['/product/form']);
    this.formulario.reset();
    this.nameProduct = '';
  }

  voltarConsulta() {
    this.router.navigate(['/product/consulta']);
  }

  buscarProduto() {
    const formValues = this.formulario.value;
    if (formValues.id != null && formValues.id == formValues.productMaster) {
      this.snackBar.open('O Produto Principal não pode ser o mesmo do cadastro.', 'ERRO', {
        duration: 3000
      });
      this.formulario.controls.productMaster.setValue(null);
      this.nameProduct = '';
    } else {
      this.productService.findProductByIdActive(formValues.productMaster).subscribe((response) => {
        this.nameProduct = response.name;
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 3000
        });
      });
    }
  }
}
